import React from 'react'

const WhyChoose = () => {
    return (
        <>

            <div className="premium-ingredients" style={{ marginTop: "-40px" }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5">
                            {/* Our Ingredients Content Start */}
                            <div className="our-ingredients-content">
                                {/* Section Title Start */}
                                <div className="section-title">
                                    <h3 className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Health Food Product</h3>
                                    <h2 className="text-anime-style-3" data-cursor="-opaque" style={{ perspective: 400 }}>
                                        <div className="split-line" style={{ display: 'block', textAlign: 'start', position: 'relative' }}>
                                           Why Choose CND Super Food Mahua Shakti Blend
                                        </div>
                                    </h2>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp',textAlign:"justify" }}>CND Super Food Mahua Shakti Blend is crafted for people who want the goodness of traditional nutrition with the quality standards of modern wellness. Inspired by the natural power of Mahua and enriched with carefully selected superfoods, this blend delivers a wholesome combination of energy, strength, and nourishment in every serving.</p>
                                </div>
                                {/* Section Title End */}
                                {/* Ingredients Body Start */}
                                {/* <div className="ingredients-body wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                    <h3>Quality Assurance</h3>
                                    <ul>
                                        <li>In-House Lab Testing</li>
                                        <li>Lab-Tested for Purity</li>
                                        <li>Strict Ingredient Checks</li>
                                        <li>Safe &amp; Smart Packaging</li>
                                    </ul>
                                </div> */}
                                {/* Ingredients Body End */}
                            </div>
                            {/* Our Ingredients Content End */}
                        </div>
                        <div className="col-lg-7">
                            {/* Ingredients Image box Start */}
                            <div className="ingredients-image-box">
                                {/* Our Ingredients Image Start */}
                                <div className="our-ingredients-image">
                                    <figure className="image-anime">
                                        <img src="assets/img/mahua.png" alt />
                                    </figure>
                                </div>
                                <div className="ingredient-item-list">
                                    {/* <div className="ingredient-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                        <div className="icon-box">
                                            <img src="assets/images/icon-ingredient-item-1.svg" alt />
                                        </div>
                                        <div className="ingredient-item-content">
                                            <h3>Sourced from Trusted Farm</h3>
                                            <p>Sustainable method to grow nutrient rich ingredients without harmful.</p>
                                        </div>
                                    </div> */}
                                    {/* Ingredient Item End */}
                                    {/* Ingredient Item Start */}
                                    <div className="ingredient-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                        <div className="icon-box">
                                            <img src="assets/images/icon-ingredient-item-2.svg" alt />
                                        </div>
                                        <div className="ingredient-item-content">
                                            <h3>Our Mission</h3>
                                            <p style={{textAlign:"justify"}}>At CND Super Food, our mission is to bring the timeless wisdom of traditional Indian nutrition into modern lifestyles through pure, natural, and high-quality superfood products. </p>
                                        </div>
                                    </div>
                                    {/* Ingredient Item End */}
                                    {/* Ingredient Item Start */}
                                    <div className="ingredient-item wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                        <div className="icon-box">
                                            <img src="assets/images/icon-ingredient-item-3.svg" alt />
                                        </div>
                                        <div className="ingredient-item-content">
                                            <h3>Our Vision</h3>
                                            <p style={{textAlign:"justify"}}>Our vision is to become a trusted leader in the natural superfood industry by reviving the nutritional heritage of India and transforming it into innovative wellness solutions for the modern world.</p>
                                        </div>
                                    </div>
                                    {/* Ingredient Item End */}
                                </div>
                                {/* Ingredient Item List ENd */}
                            </div>
                            {/* Ingredients Image box End */}
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default WhyChoose